import { Button, CircularProgress } from "@mui/material";
import { Card } from "src/components/UI/Card";
import { EnableContentStrategyDialog } from "./EnableContentStrategyDialog";
import { useContentStrategyMutation } from "../hooks/useContentStrategyMutation";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

function CSNoDataFound({siteSoftDeleted}: {siteSoftDeleted: boolean}) {

  const { _id: siteId, user_id: userId } = useSelector((state: RootState) => state?.siteAudit?.siteAuditDetails) ?? {};

  const {
    dialogOpen,
    setDialogOpen,
    keywords,
    setKeywords,
    handleEnableContentStrategy,
    runContentStrategyMutation
  } = useContentStrategyMutation();

  return (
    <>
      <Card>
        <div className="px-6">
          <p className="text-primary font-semibold text-3xl">Content Strategy</p>

          <div className="flex flex-col items-center justify-center gap-6 p-6 pb-0 w-full mt-2.5 mb-2.5">
            {runContentStrategyMutation.isPending ? (
              <div className="flex flex-col items-center justify-center gap-3 text-center min-h-[16rem]">
                <CircularProgress size={64} />
                <p className="font-semibold text-lg text-[#1D2939] mt-2">
                  Orbit AI Content Strategy is running...
                </p>
                <p className="font-normal text-sm text-[#667085] max-w-md">
                  This may take a few moments while we generate your customized content strategy and topic recommendations.
                </p>
              </div>
            ) : (
              <>
                <h3 className="font-medium text-lg text-center text-[#1D2939]">
                  No Content Strategy Data Found
                </h3>
                <p className="font-normal text-sm leading-5 text-center text-[#667085]">
                  It looks like Content Strategy hasn't been run or completed for this site yet. Navigate to your SEO dashboard to start generating content strategies.
                </p>
                <Button
                  onClick={() => setDialogOpen(true)}
                  disabled={siteSoftDeleted}
                  variant="contained"
                  sx={{
                    backgroundColor: 'var(--color-primary, #120242)',
                    color: '#FFFFFF',
                    textTransform: 'none',
                    fontWeight: 400,
                    borderRadius: '4px',
                    fontSize: '14px',
                    py: 1,
                    px: 3.5,
                    '&:hover': {
                      backgroundColor: 'rgba(18, 2, 66, 0.9)'
                    }
                  }}
                >
                  Run Content Strategy AI
                </Button>
              </>
            )}
          </div>
        </div>
      </Card>

      <EnableContentStrategyDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        keywords={keywords}
        setKeywords={setKeywords}
        onEnable={(keywords) => handleEnableContentStrategy(keywords, { siteId, userId })}
        isLoading={runContentStrategyMutation.isPending}
      />
    </>
  );
}

export default CSNoDataFound;
